import { render, staticRenderFns } from "./majorChartBar.vue?vue&type=template&id=7352349f&"
import script from "./majorChartBar.vue?vue&type=script&lang=js&"
export * from "./majorChartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports